// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"a81aa1a4","36":"de7fbfe7","272":"cb54df41","925":"c1b3f9f4"}[chunkId] + ".chunk.css";
};